import OrderOptimizerRailyDetailsHiddenDetailsDriver from "../types/order-optimizer-raily-details-hidden-details-driver";
import { OrderOptimizerRailyDetailsHiddenDetailsDriverListItem } from "../types/order-optimizer-raily-details-hidden-details-driver-list";
import OrderOptimizerRailyDetailsHiddenDetailsDriverSelectOption from "../types/order-optimizer-raily-details-hidden-details-driver-select-option";

const createPotentialDriver = (
  potentialDriver: OrderOptimizerRailyDetailsHiddenDetailsDriverListItem
): OrderOptimizerRailyDetailsHiddenDetailsDriver => {
  return {
    driver: potentialDriver.driver,
    taxiDriverAssociationUuid: potentialDriver.taxiDriverAssociationUuid,
    saDistance: potentialDriver.saDistance,
    taxiCorporation: potentialDriver.taxiCorporation,
  };
};

const createPotentialDriverSelectOption = (
  potentialDriver: OrderOptimizerRailyDetailsHiddenDetailsDriver
): OrderOptimizerRailyDetailsHiddenDetailsDriverSelectOption => {
  return {
    label: potentialDriver.driver,
    subText: potentialDriver.taxiCorporation,
    value: potentialDriver,
  };
};

const createPotentialDriverSelectOptions = (
  data: OrderOptimizerRailyDetailsHiddenDetailsDriverListItem[]
): OrderOptimizerRailyDetailsHiddenDetailsDriverSelectOption[] => {
  const workers = data.map(createPotentialDriver);
  return workers.map(createPotentialDriverSelectOption);
};

const orderOptimizerRailyDetailsHiddenDetailsDriverFactory = {
  createPotentialDriverSelectOption,
  createPotentialDriverSelectOptions,
};

export default orderOptimizerRailyDetailsHiddenDetailsDriverFactory;
